<template>
  <div>
    <v-dialog class="new-event-dialog" :title="dialogTitle" :visible.sync="newEventDialogVisible"
      :modal-append-to-body="false" :scrollbar="false" @open="onOpen" @closed="onClosed">
      <el-scrollbar class="custom">
        <el-form ref="form" :model="form" :rules="formRules" label-position="top">
          <el-row type="flex" :gutter="50">
            <el-col :span="12">
              <el-form-item prop="input" label="Subject">
                <el-input v-model="form.input" placeholder="Subject">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="20">
            <el-col :span="12">
              <el-form-item prop="startDatetime" label="Start Datetime">
                <div class="date-time">
                  <el-date-picker class="date-picker" v-model="startDateTime" value-format="yyyy-MM-dd" type="date"
                    placeholder="Select date" :editable="false" :clearable="false" />
                  <el-time-select class="time-selecter" v-model="startSelectTime" :picker-options="{
                    start: theMoment,
                    end: '23:30',
                    minTime: startMoment,
                  }" :editable="false" placeholder="Select period" value-format="HH:mm" :clearable="false"
                    ref="startTime" />
                </div>
              </el-form-item>
            </el-col>
            <el-col class="date-time" :span="12">
              <el-form-item prop="endDatetime" label="End Datetime">
                <el-date-picker class="date-picker" v-model="endDateTime" :picker-options="endTime"
                  value-format="yyyy-MM-dd" type="date" placeholder="Select date" :editable="false"
                  :clearable="false" />
                <el-time-select class="time-selecter" v-model="endSelectTime" :picker-options="{
                  start: theMoment,
                  end: '23:30',
                  minTime: startMoment,
                }" :editable="false" placeholder="Select period" value-format="HH:mm" :clearable="false"
                  ref="startTime" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" class="tinymceEditor">
            <el-col :span="24">
              <div class="description">Description</div>
              <TinymceEditor v-model="content" :height="300" />
            </el-col>
          </el-row>
          <el-button type="danger" plain @click="showSelectDialog">Select SE/CE</el-button>
        </el-form>
        <div class="table-wrapper" v-if="seList.length > 0">
          <el-table :data="seList">
            <el-table-column prop="Name" label="SE/CE Name" min-width="100" />
            <el-table-column prop="City" label="City" min-width="90" />
            <el-table-column prop="Hospital" label="Hospital / Institution" min-width="180" />
            <el-table-column prop="Department" label="Department" min-width="110" />
            <el-table-column prop="MLName" label="MSL Name" min-width="120" />
            <el-table-column prop="TeamName" label="Team" min-width="80" />
            <el-table-column label="Operation" align="center" width="120">
              <div class="operation-actions" slot-scope="{ $index, row }">
                <el-button type="text" icon="el-icon-delete" @click="onDeleteSelect($index, row.SEID)"></el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </el-scrollbar>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()"> save </el-button>
        <el-button @click="onClosed">cancel </el-button>
      </div>
    </v-dialog>
    <SelectSeDialog :visible.sync="selectSeDialogVisible" :selected="seList" @select="onSelect"
      @closed="onSelectDialogClosed" />
  </div>
</template>
<script>
// import moment from "moment";
import TinymceEditor from "../../components/tinymce-editor";
import SelectSeDialog from "../event/select-se-dialog";
export default {
  name: "new-event-dialog",
  components: { TinymceEditor, SelectSeDialog },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  created() {
    const currentDate = this.moment();
    const startMoment = currentDate.format("HH:mm");
    if (currentDate.format("mm") <= 30) {
      const theMoment = currentDate.format("HH:30");
      this.theMoment = theMoment;
    } else {
      const theMoment = currentDate.add(1, "hours");
      this.theMoment = theMoment.format("HH:00");
    }
    this.startMoment = startMoment;
  },
  data() {
    return {
      newEventDialogVisible: this.visible,
      dateFormat: "yyyy-mm-dd hh:mm",
      timeFormat: " HH:mm:ss",
      startDateTime: "",
      endDateTime: "",
      endSelectTime: "",
      startSelectTime: "",
      theMoment: "",
      startMoment: "",
      checkedList: [],
      seList: [],
      form: {
        input: "",
        startDatetime: "",
        endDatetime: "",
      },
      hidePushDialog: false,
      selectSeDialogVisible: false,

      content: "",
      formRules: {
        input: [
          { required: true, message: "Please input Subject", tigger: "blur" },
        ],
        startDatetime: [
          {
            required: true,
            message: "Please select start date and time",
            tigger: "change",
          },
        ],
        endDatetime: [
          {
            required: true,
            message: "Please select end date and time",
            tigger: "change",
          },
        ],
      },
    };
  },
  watch: {
    visible(value) {
      this.newEventDialogVisible = value;
    },
    newEventDialogVisible(value) {
      this.$emit("update:visible", value);
    },
    startDateTime(value) {
      this.form.startDatetime =
        value && this.startSelectTime
          ? `${value}T${this.startSelectTime}:00.000Z`
          : "";
    },
    startSelectTime(value) {
      this.form.startDatetime =
        value && this.startDateTime
          ? `${this.startDateTime}T${value}:00.000Z`
          : "";
    },
    endDateTime(value) {
      this.form.endDatetime =
        value && this.endSelectTime
          ? `${value}T${this.endSelectTime}:00.000Z`
          : "";
    },
    endSelectTime(value) {
      this.form.endDatetime =
        value && this.endDateTime ? `${this.endDateTime}T${value}:00.000Z` : "";
    },
  },
  methods: {
    onOpen() { },
    showSelectDialog() {
      this.hidePushDialog = true;
      this.newEventDialogVisible = false;
      this.selectSeDialogVisible = true;
    },
    submit() {
      var checkedList = [];
      this.seList.forEach((e) => {
        checkedList.push({ seId: e.SEID });
        this.checkedList = checkedList;
      });
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.axios
            .post("event/add", {
              subject: this.form.input,
              startDt: this.form.startDatetime,
              endDt: this.form.endDatetime,
              content: this.content,
              se: this.checkedList,
            })
            .then(({ code, msg }) => {
              if (code === 200) {
                this.$emit("success");
                this.$message.success(`Create event successfully`);
                this.$emit("update:visible", false);
              } else {
                this.$message.error(msg);
              }
            });
        }
      });
    },

    onClosed() {
      if (!this.hidePushDialog) {
        this.seList = [];
        this.formRules.input[0].required = false;
        this.formRules.startDatetime[0].required = false;
        this.formRules.endDatetime[0].required = false;
        this.form.input = "";
        this.startDateTime = "";
        this.startSelectTime = "";
        this.endDateTime = "";
        this.endSelectTime = "";
        this.content = " ";
        this.$refs.form.resetFields();
        this.$emit("update:visible", false);
      }
    },
    onSelect(selected) {
      // console.log(selected);
      this.seList = this.seList.concat(selected);
    },
    onDeleteSelect(index) {
      //  删除
      this.seList.splice(index, 1);
    },
    onSelectDialogClosed() {
      this.newEventDialogVisible = true;
      this.hidePushDialog = false;
    },
  },

  computed: {
    endTime() {
      let _this = this;
      return {
        disabledDate: (time) => {
          if (_this.startDateTime) {
            return time < _this.startDateTime;
          }
        },
      };
    },
    dialogTitle() {
      return `New Event`;
    },
  },
};
</script>
<style lang="scss" scope>
.el-dialog {
  width: 800px;
}

.new-event-dialog {
  width: 800px;

  .el-scrollbar__wrap {
    margin-bottom: 0px;
  }

  .el-form {
    padding: 0px 60px;
    margin-bottom: 20px;

    h4 {
      margin-bottom: 5px;
    }

    .el-form-item {
      &:not(.no-mt) {
        margin-bottom: 10px !important;
      }

      &.no-mb {
        margin-bottom: 0 !important;
      }

      // .el-form-item__label {
      //   padding: 0;
      // }
      &.cate {
        .el-radio-group {
          display: flex;
          padding: 4px 0;
        }
      }
    }

    .el-form-item.request-type {
      .el-radio {
        display: block;
        line-height: 32px;
      }
    }

    .tinymceEditor {
      margin-bottom: 10px;
    }
  }

  .el-row {

    &.greetings-settings,
    &.request-type {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    &.request-type {
      margin-top: 10px;
      padding: 30px 0;
      background-color: #f4f7f9;
    }

    .el-col.settings {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .date-time {
      display: flex;
      align-items: flex-end;

      .el-date-editor {
        min-width: 130px;
        max-width: 130px;
        width: 100% !important;

        .el-input__inner {
          padding-right: 10px !important;
        }

        &:first-child {
          margin-right: 5px;
        }
      }
    }

    .description {
      padding: 8px 0px;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
